const useIsTg = () => {
    return !!window.Telegram.WebApp.initData
}

export default useIsTg;
